import { isString } from 'lodash-es';

import { MaskingOptions, Format } from './interfaces';

/**
 * get masking value for masking props
 * @param value field input
 * @param as optional format provided
 */
export function getMasking(value: any, as?: Format): MaskingOptions | undefined {
  if (!as) {
    return undefined;
  }

  switch (as) {
    case 'ImmiCard':
      return {
        mask: '***999999'
      };
    case 'MobileNumber':
      return {
        mask: isString(value) ? (value.charAt(0) === '+' ? 'abc dxx xxx xxx' : 'adxx xxx xxx') : '',
        formatChars: { x: '[0-9]', a: '[+0]', b: '[6]', c: '[1]', d: '[4]' }
      };
    case 'HomePhoneNumber':
      return {
        mask: isString(value) ? (value.charAt(0) === '+' ? 'abc d xxxx xxxx' : 'ad xxxx xxxx') : '',
        formatChars: { x: '[0-9]', a: '[+0]', b: '[6]', c: '[1]', d: '[2378]' }
      };
    case 'WorkPhoneNumber':
      return {
        mask: isString(value)
          ? value.charAt(0) === '+'
            ? value.charAt(3) === '4' || value.charAt(4) === '4'
              ? 'abc dxx xxx xxx'
              : 'abcd xxxx xxxx'
            : value.charAt(0) === '0'
            ? value.charAt(1) === '4'
              ? 'adxx xxx xxx'
              : 'ad xxxx xxxx'
            : value.charAt(0) === '1' && value.charAt(1) === '8'
            ? 'aeff xxx xxx'
            : value.charAt(0) === '1' &&
              value.charAt(1) === '3' &&
              value.charAt(2) === '0' &&
              (value.charAt(3) === '0' || value.charAt(4) === '0')
            ? 'aeff xxx xxx'
            : 'aex xxx'
          : '',
        formatChars: {
          x: '[0-9]',
          a: '[+01]',
          b: '[6]',
          c: '[1]',
          d: '[23478]',
          e: '[38]',
          f: '[0]'
        }
      };
    case 'MedicareCardNumber':
      return {
        mask: '9999 99999 9',
        formatChars: { 9: '[0-9]' }
      };
    case 'MedicareRefNumber':
      return {
        mask: '9',
        formatChars: { 9: '[1-9]' }
      };
    case 'AusPassport':
      return {
        mask: isString(value) ? (parseInt(value.charAt(1)) ? '*9999999' : '**9999999') : ''
      };
    case 'ForeignPassport':
      return {
        mask: '**************'
      };
    case 'CreditCard':
      return {
        mask: '9999 9999 9999 9999'
      };
  }
}
